import type { LocalProject } from '@console/reducers/projects';
import type { Theme } from '@mui/material';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import type { StyleRules, WithStyles } from '@mui/styles';
import createStyles from '@mui/styles/createStyles';
import withStyles from '@mui/styles/withStyles';

export type PeriodExpiredMessagePropsMappedFromState = {
  selectedProject: LocalProject;
};

export type PeriodExpiredMessagePropsMappedFromDispatch = Record<string, never>;

const styles = (theme: Theme): StyleRules =>
  createStyles({
    alert: {
      padding: theme.spacing(),
      border: `solid 1px rgb(0, 151, 245)`,
      borderRadius: 5,
      backgroundColor: 'rgb(219, 241, 255)'
    },
    typography: {
      margin: `${theme.spacing(1)}`
    },
    section: {
      paddingTop: theme.spacing(3)
    }
  });

type PeriodExpiredMessageProps = PeriodExpiredMessagePropsMappedFromState &
  PeriodExpiredMessagePropsMappedFromDispatch &
  WithStyles<typeof styles>;

const PeriodExpiredMessage: React.FC<PeriodExpiredMessageProps> = ({
  classes,
  selectedProject
}) => {
  const isGiftDistributionPeriodExpired =
    selectedProject?.giftDistributionPeriod &&
    new Date(selectedProject.giftDistributionPeriod.endAt) < new Date();

  return (
    <>
      {selectedProject?.isAnyContentPartnerReviewRequested &&
        !selectedProject.isCancelled &&
        isGiftDistributionPeriodExpired && (
          <section className={classes.section}>
            <Grid
              container
              item
              wrap="nowrap"
              alignItems="center"
              xs={12}
              className={classes.alert}
            >
              <Typography
                variant="body2"
                color="textPrimary"
                className={classes.typography}
              >
                掲載期間やギフト配布期間が過去の日付に設定されています。
                <br />
                期間延長の場合は、サポートもしくは弊社担当者までご連絡ください。
              </Typography>
            </Grid>
          </section>
        )}
    </>
  );
};

export default withStyles(styles)(PeriodExpiredMessage);
